import React, {
    useState
} from 'react';

import PropTypes from 'prop-types';

import {
    RIQInfoPopover
} from '../../../../components/RIQPopover.jsx';


WizardSectionField.propTypes = {
    className: PropTypes.string,
    prompt: PropTypes.node.isRequired,
    description: PropTypes.node,
    title: PropTypes.string,
    children: PropTypes.node
};

export function WizardSectionField({className, prompt, title, description, children}) {

    return (
        <div className={`tlw-mx-8 tlw-flex tlw-flex-col ${className || ''}`}>
            <div
                className='tlw-mb-2.5 tlw-text-gray-900'
            >
                {prompt}

                {description &&
                    <RIQInfoPopover
                        title={title}
                        description={description}
                    />
                }
            </div>

            {children}
        </div>
    );
}


WizardSectionPanel.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    description: PropTypes.node,
    collapsable: PropTypes.bool,
    isInitiallyCollapsed: PropTypes.bool,
    children: PropTypes.node
};

export function WizardSectionPanel({className, title, subtitle, description, collapsable, isInitiallyCollapsed = false, children}) {

    const [isCollapsed, setIsCollapsed] = useState(isInitiallyCollapsed);

    return (
        <div className='tlw-mb-10 tlw-flex tlw-flex-col tlw-rounded tlw-bg-white tlw-shadow-panel'>

            <div
                className='tlw-flex tlw-gap-[16px] tlw-border-0 tlw-border-b tlw-border-solid tlw-border-gray-300 tlw-px-7.5 tlw-py-5'
            >
                <div className='tlw-flex tlw-min-w-0 tlw-flex-1 tlw-flex-col'>
                    <h3 className='tlw-m-0 tlw-flex tlw-max-h-[43px] tlw-grow tlw-overflow-hidden tlw-text-ellipsis tlw-whitespace-nowrap tlw-text-base tlw-leading-22 tlw-text-gray-900'>
                        <span className='tlw-min-w-0 tlw-overflow-hidden tlw-text-ellipsis'>{title}</span>

                        {description &&
                            <span className='tlw-ml-2'>
                                <RIQInfoPopover
                                    title={title}
                                    description={description}
                                />
                            </span>
                        }
                    </h3>

                    {subtitle &&
                        <h6 className='tlw-my-1 tlw-text-sm'>
                            {subtitle}
                        </h6>
                    }
                </div>

                {collapsable &&
                    <button
                        type='button'
                        className='tlw-border-0 tlw-bg-transparent tlw-text-gray-600'
                        onClick={() => setIsCollapsed(!isCollapsed)}
                    >
                        <span
                            className={`fa ${isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'}`}
                        />
                    </button>
                }
            </div>

            <div
                className={`tlw-flex tlw-flex-col ${isCollapsed ? 'tlw-h-0 tlw-overflow-hidden' : `tlw-h-auto ${className || ''}`}`}
            >
                {children}
            </div>
        </div>
    );
}
